import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "official-info-section text-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "official-info-title" }, "Официальная информация", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "info-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.information, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col"
          }, [
            _createElementVNode("img", {
              src: item.icon,
              alt: "icon1",
              class: "info-icon"
            }, null, 8, _hoisted_5),
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}